// Load Sentry early to report all errors
import * as Sentry from '@sentry/browser'
import { IGNORED_ERROR_PATTERNS, shouldIgnoreError } from './controllers/shared/CatchError'
import { shouldFilterCspViolation, logFilteredCspViolation } from './controllers/shared/CspErrorFilter'
/* eslint-enable no-undef */

// Stimulus
import './controllers'

// Turbo
import '@hotwired/turbo-rails'

Sentry.init({
  environment: document.querySelector('meta[name="app:env"]').getAttribute('content'),
  release: document.querySelector('meta[name="app:revision"]').getAttribute('content'),
  dsn: 'https://a2dd90458f3c4ca2bb4118777178d99f@sentry.io/785453',
  ignoreErrors: [
    'NS_ERROR_NOT_INITIALIZED',
    // Add all centralized error patterns
    ...IGNORED_ERROR_PATTERNS.errorTypes,
    ...IGNORED_ERROR_PATTERNS.messagePatterns
  ],
  beforeSend (event) {
    // Filter CSP violations from third-party sources
    if (event.type === 'csp' && event.logger === 'csp') {
      const cspData = event.contexts?.csp
      const userAgent = event.request?.headers?.['User-Agent'] || ''

      if (shouldFilterCspViolation(cspData, userAgent)) {
        logFilteredCspViolation(cspData, userAgent)
        return null // Don't send to Sentry
      }
    }

    // Filter regular JavaScript exceptions
    if (event.exception) {
      const error = event.exception.values[0]
      if (error && error.value) {
        // Create a mock error object for shouldIgnoreError function
        const mockError = {
          name: error.type || '',
          message: error.value || '',
          scriptUrl: event.request?.url || ''
        }

        if (shouldIgnoreError(mockError)) {
          return null // Don't send to Sentry
        }
      }
    }
    return event
  }
})

// Set global environment variables
// - APP_ENV is needed by DevLog.js
window.APP_ENV = document.querySelector('meta[name="app:env"]').getAttribute('content')

// require('@rails/activestorage').start()
// require('../channels')

// Add Content Security Policy nonce to Turbo requests
// https://discuss.rubyonrails.org/t/problems-integrating-hotwire-into-existing-rails-project/77990/13
document.addEventListener('turbo:before-fetch-request', function (event) {
  event.detail.fetchOptions.headers['X-Turbo-Nonce'] = document
    .querySelector("meta[name='csp-nonce']")
    .getAttribute('content')
})

// Preserve nonces in scripts and styles on Turbo cache
document.addEventListener('turbo:before-cache', function () {
  document
    .querySelectorAll('script[nonce]')
    .forEach((element) => element.setAttribute('nonce', element.nonce))
  document
    .querySelectorAll('style[nonce]')
    .forEach((element) => element.setAttribute('nonce', element.nonce))
})
